/**
 * FilterField — a labeled wrapper for a single filter control.
 *
 * Gives every filter (search box, select, segmented toggle group) a consistent
 * small uppercase label above it, matching the labeled-grid style already used
 * on the Done and Audit pages. Lay several out in a `flex flex-wrap … items-end`
 * row (or a grid) so the controls bottom-align regardless of label presence.
 *
 *   <FilterField label="Distribution center">
 *     <select …>…</select>
 *   </FilterField>
 *
 * label?    — uppercase caption; omit for an unlabeled cell (keeps alignment)
 * className — extra classes on the wrapper (e.g. `flex-1 min-w-[200px]`, `ml-auto`)
 */
export default function FilterField({ label, children, className = '' }) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <span className="text-[10px] uppercase tracking-wider text-slate-500 leading-none h-3">
        {label}
      </span>
      {children}
    </div>
  )
}
